import React, { useState } from 'react';

import './Projects.css';

import ProjectCard from '../ProjectCard';
import ProjectModal from '../ProjectModal';

import ComfyUIImg from './../../images/comfyui.png';
import RaspberryPiImg from './../../images/raspberrypi.jpg';

const PROJECTS = [
    {
        name: "ComfyUI Orchestration Bot",
        desc: "A Discord bot that remotely drives AI image generation workflows from anywhere.",
        detail: "Built a Python-based system that connects a Discord bot to a local ComfyUI server, letting users kick off AI image generation through simple chat commands. Currently powered by QWEN for image editing, the bot handles multiple requests at once using asyncio, queues up complex multi-step workflows, and sends back real-time progress updates through discord emojis! I use this on the daily for any quick edits.",
        img: ComfyUIImg,
    },
    {
        name: "Raspberry Pi Home Server",
        desc: "A self-hosted media and cloud setup running on a Raspberry Pi.",
        detail: "Turned a Raspberry Pi into a personal home server that handles media streaming, network storage, and cloud access. Plex Media Server handles movies and shows for the household, OpenMediaVault connects to a NAS for centralized file storage, and NextCloud ties it all together with remote access from anywhere. It's a lightweight, always-on setup that keeps everything in-house without relying on third-party cloud subscriptions.",
        img: RaspberryPiImg,
    },
];

const COLLEGIATE_PROJECTS = [
    {
        name: "SightByte",
        desc: "An at-home myopia assessment program that uses OpenCV webcam tracking to dynamically determine user distance and scale displayed characters accordingly. Features real-time session syncing between web and mobile via Firebase Realtime Database with session termination and timeout policies for database redundancy removal.",
        tech: ["React", "Firebase", "OpenCV", "Python"],
        award: "Senior Project",
    },
    {
        name: "Where's my Drip?",
        desc: "A community-based water fountain sharing application built on top of the Google Maps API.",
        tech: ["React", "Firebase", "Google Maps API"],
        award: "SASEhack Fall 2023 — Grand Prize & Best Pitch",
    },
    {
        name: "Handi",
        desc: "AI-powered hand gesture recognition system for real-time sign language translation.",
        tech: ["TensorFlow", "Python", "OpenCV"],
        link: "https://github.com/nickaplan/swamphacks",
        devpost: "https://devpost.com/software/handi-nyr1sk",
        award: "SwampHacks 8 — Google Cloud Winner",
    },
    {
        name: "VR Zen Garden",
        desc: "A calming VR experience where users design and interact with a virtual zen garden.",
        tech: ["Unity", "C#", "VR"],
        link: "https://github.com/tam-huynh/VR-Zen-Garden",
    },
];

const ProjectSection = () => {
    const [selectedProject, setSelectedProject] = useState(null);

    return(
        <div id="Projects" class="proj-section">
            <section class="proj-section">
                <h2 class="work-title">Projects</h2>
                <p class="section__subtitle section__subtitle--work">Fun projects I currently work on in my free time</p>

                <div class="proj-list">
                    {PROJECTS.map((project, index) => (
                        <ProjectCard
                            key={index}
                            name={project.name}
                            desc={project.desc}
                            img={project.img}
                            onClick={() => setSelectedProject(project)}
                        />
                    ))}
                </div>

                <div class="collegiate-section">
                    <h3 class="collegiate-heading">Collegiate Projects</h3>
                    <ul class="collegiate-list">
                        {COLLEGIATE_PROJECTS.map((project, index) => (
                            <li key={index} class="collegiate-item">
                                <div class="collegiate-info">
                                    <span class="collegiate-name">{project.name}</span>
                                    <span class="collegiate-desc">{project.desc}</span>
                                    <div class="collegiate-tech">
                                        {project.tech.map((t, i) => (
                                            <span key={i} class="collegiate-tag">{t}</span>
                                        ))}
                                    </div>
                                    {project.award && (
                                        <span class="collegiate-award">
                                            <i class="fa-solid fa-trophy"></i> {project.award}
                                        </span>
                                    )}
                                </div>
                                <div class="collegiate-links">
                                    {project.link && (
                                        <a href={project.link} target="_blank" rel="noopener noreferrer" title="GitHub">
                                            <i class="fa-brands fa-github"></i>
                                        </a>
                                    )}
                                    {project.devpost && (
                                        <a href={project.devpost} target="_blank" rel="noopener noreferrer" title="Devpost">
                                            <i class="fa-solid fa-d"></i>
                                        </a>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div class="connect-section">
                    <h2 class="connect-heading">Want to connect?</h2>
                    <p class="connect-subtext">Reach me here</p>
                    <div class="connect-arrow">&#8595;</div>
                </div>
            </section>

            {selectedProject && (
                <ProjectModal
                    project={selectedProject}
                    onClose={() => setSelectedProject(null)}
                />
            )}
        </div>
    )
}

export default ProjectSection;
